const HERO_FEATURES = [
  { label: 'Ada / Parsel Sorgu', icon: 'map' },  { label: 'Fiyat Analizi', icon: 'chart' },
  { label: 'İmar Durumu', icon: 'plan' },
  { label: '3D Bina Çiz', icon: 'cube' },
  { label: 'Arazi Röntgeni', icon: 'scan' },
  { label: 'Güneş - Rüzgar', icon: 'sun' },
  { label: 'Ne Yetişir?', icon: 'leaf' },
  { label: 'EİDS İlan', icon: 'listing' },
];

function FeatureIcon({ type }) {
  const common = {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'none',
    'aria-hidden': true,
    focusable: 'false',
  };

  switch (type) {
    case 'chart':
      return (
        <svg {...common}>
          <path d="M4 19V5M8 19V11M12 19V8M16 19V13M20 19V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'plan':
      return (
        <svg {...common}>
          <rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
          <path d="M8 9H16M8 13H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'cube':
      return (
        <svg {...common}>
          <path d="M12 3L20 8V16L12 21L4 16V8L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      );
    case 'scan':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="2" />
          <path d="M12 5V3M12 21V19M5 12H3M21 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'sun':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
          <path d="M12 2V4M12 20V22M4 12H2M22 12H20M5 5L6.5 6.5M17.5 17.5L19 19M19 5L17.5 6.5M6.5 17.5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'leaf':
      return (
        <svg {...common}>
          <path d="M12 21C12 21 5 16 5 10C5 6 8 4 12 4C16 4 19 6 19 10C19 16 12 21 12 21Z" stroke="currentColor" strokeWidth="2" />
          <path d="M12 21V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'listing':
      return (
        <svg {...common}>
          <path d="M7 4H17L20 8V19C20 20.1 19.1 21 18 21H6C4.9 21 4 20.1 4 19V8L7 4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M8 11H16M8 15H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <path d="M4 10L12 4L20 10V19C20 20.1 19.1 21 18 21H6C4.9 21 4 20.1 4 19V10Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M9 21V13H15V21" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      );
  }
}

export function HeroFeatureStrip() {
  return (
    <div class="pp-landing-hero-v2__features-wrap">
      <section class="pp-landing-hero-v2__features" aria-label="ProParcel özellikleri">
        <ul class="pp-landing-hero-v2__features-grid" role="list">
          {HERO_FEATURES.map((item) => (
            <li class="pp-landing-hero-v2__feature" key={item.label}>
              <span class={`pp-landing-hero-v2__feature-icon pp-landing-hero-v2__feature-icon--${item.icon}`}>
                <FeatureIcon type={item.icon} />
              </span>
              <span class="pp-landing-hero-v2__feature-label">{item.label}</span>
            </li>
          ))}
        </ul>
      </section>

      <div class="pp-landing-hero-v2__features-scroll" role="group" aria-label="Sayfa gezinme">
        <button
          type="button"
          class="pp-landing-scroll-hint pp-landing-hero-v2__scroll-hint"
          data-landing-scroll="down"
          aria-label="Tanıtımlar bölümüne git"
        >
          <span class="pp-landing-scroll-hint__label">Tanıtımlar</span>
          <i class="fas fa-chevron-down" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}